import { useEffect, useState } from "react";
import { api, errMsg } from "../../lib/api";
import { SNAPSHOT } from "../../lib/snapshot";

export default function VerificationTestCard({ kind, options }) {
  const [enabled, setEnabled] = useState(false);
  const [selected, setSelected] = useState("");
  const [mode, setMode] = useState("in_person");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const eligible = kind === "registration"
    ? options.filter((o) => o.complimentary_rule === "none" && (o.attendance_modes || []).length)
    : options.filter((o) => o.id !== "custom" && Number(o.price) > 0);
  const choice = eligible.find((o) => o.id === selected) || eligible[0];
  const modes = choice?.attendance_modes || ["in_person"];
  useEffect(() => {
    if (SNAPSHOT) return;
    let alive = true;
    const refresh = () => api.get("/public/verification-entry", { params: { _fresh: Date.now() } })
      .then(({ data }) => { if (alive) setEnabled(data.enabled === true); })
      .catch(() => { if (alive) setEnabled(false); });
    refresh(); window.addEventListener("focus", refresh);
    return () => { alive = false; window.removeEventListener("focus", refresh); };
  }, []);
  if (!enabled || !choice || SNAPSHOT) return null;
  const start = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try {
      const body = kind === "registration"
        ? { kind, category_id: choice.id, attendance_mode: modes.includes(mode) ? mode : modes[0] }
        : { kind, package_id: choice.id };
      const { data } = await api.post("/public/verification-entry", body);
      window.location.assign(data.path);
    } catch (e) { setError(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="flex flex-col items-center rounded-lg border-2 border-burgundy bg-white p-5 text-center" data-testid={`public-${kind}-test-card`}>
      <strong className="text-xl text-burgundy">TEST</strong>
      <span className="mt-1 text-xl font-bold text-burgundy">BSD $1.00</span>
      <span className="mt-2 text-sm font-semibold text-navy">{kind === "registration" ? "Attendee verification" : "Sponsorship verification"}</span>
      <label className="mt-3 w-full text-left text-xs text-navy">{kind === "registration" ? "Attendee category" : "Sponsorship package"}
        <select className="field-input mt-1" value={choice.id} disabled={busy} onChange={(e) => setSelected(e.target.value)}>
          {eligible.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
      </label>
      {kind === "registration" && <label className="mt-2 w-full text-left text-xs text-navy">Attendance
        <select className="field-input mt-1" disabled={busy} value={modes.includes(mode) ? mode : modes[0]} onChange={(e) => setMode(e.target.value)}>
          {modes.map((m) => <option key={m} value={m}>{m === "virtual" ? "Virtual" : "In-Person"}</option>)}
        </select>
      </label>}
      <p className="mt-3 text-xs text-slate-600">Real BSD $1.00 card charge when you submit payment. Excluded from event totals.</p>
      <button type="button" className="btn-outline mt-3" disabled={busy} onClick={start}>{busy ? "Preparing checkout…" : "Start $1.00 checkout"}</button>
      {error && <p role="alert" className="mt-2 text-sm text-burgundy">{error}</p>}
    </div>
  );
}
